/* --- what has arrived since you last looked ----------------------------------
   "If I scrolled last year I want to know what you added since then" — Dragoș,
   29 Aug. Every card carries the date it was published; this marks the ones newer
   than the visitor's last look. The stored stamp only rolls forward once every
   twelve hours, so reloading or paging through does not wipe the marks you are
   still reading. First-time visitors see nothing — everything would be new. */
(function () {
  'use strict';
  var SEEN = 'ko:seen', ROLLED = 'ko:seenAt', HALF_DAY = 43200000;
  function run() {
    if (!document.querySelector('.acard[data-added]')) return;
    var seen = null, rolled = 0;
    try { seen = localStorage.getItem(SEEN); rolled = +localStorage.getItem(ROLLED) || 0; } catch (e) { return; }
    var now = Date.now();
    if (seen) {
      var cut = parseInt(seen, 10);
      var n = 0;
      Array.prototype.forEach.call(document.querySelectorAll('.acard[data-added]'), function (c) {
        var added = parseInt(c.getAttribute('data-added'), 10);
        if (!added || added <= cut) return;
        c.classList.add('is-new');
        var tag = c.querySelector('.cardnew');
        if (tag) tag.hidden = false;
        n++;
      });
      document.documentElement.setAttribute('data-newcount', String(n));
    }
    if (!seen || now - rolled > HALF_DAY) {
      try { localStorage.setItem(SEEN, String(Math.floor(now / 1000))); localStorage.setItem(ROLLED, String(now)); } catch (e) {}
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();

/* --- picking a print — removed 30 Aug (Rareș) ---------------------------------
   A click used to dim the rest of the grid to 28% and hold the navigation for
   170ms so the choice was visible. Rareș does not want the surrounding prints
   to change at all when one is tapped. Both halves are gone: the dim had no
   purpose without the hold, and the hold had no purpose without the dim — it
   was 170ms of pure waiting on top of an already slow product page.
   Do not reinstate either without asking him. The matching CSS block in
   kommon-theme.css was removed in the same pass. */

/* --- scroll lock -------------------------------------------------------------
   documentElement.style.overflow='hidden' does not stop iOS Safari scrolling the
   page behind an overlay: you open an image, tap next, and the page underneath has
   slid away. Pin the body and put the scroll position back on release. Reference
   counted, so closing a drawer under an open lightbox does not unlock the page. */
var koLockN = 0, koLockY = 0;
function koScrollLock() {
  if (koLockN++ > 0) return;
  koLockY = window.pageYOffset || document.documentElement.scrollTop || 0;
  document.documentElement.style.overflow = 'hidden';
  var b = document.body.style;
  b.position = 'fixed'; b.top = (-koLockY) + 'px'; b.left = '0'; b.right = '0'; b.width = '100%';
}
function koScrollUnlock() {
  if (koLockN === 0) return;
  if (--koLockN > 0) return;
  document.documentElement.style.overflow = '';
  var b = document.body.style;
  b.position = ''; b.top = ''; b.left = ''; b.right = ''; b.width = '';
  window.scrollTo(0, koLockY);
}

/* ============================================================
   Kommon Objects — storefront behaviour
   No framework, no build step. Everything degrades to a working
   page if this file fails to load.
   ============================================================ */
(function () {
  'use strict';

  var $  = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- toast ---------- */
  var toastEl = $('#toast'), toastT;
  function toast(msg) {
    if (!toastEl) return;
    toastEl.textContent = msg;
    toastEl.classList.add('on');
    clearTimeout(toastT);
    toastT = setTimeout(function () { toastEl.classList.remove('on'); }, 2600);
  }

  /* ---------- mobile menu ---------- */
  (function () {
    var btn = $('#menuBtn'), menu = $('#mobmenu'), close = $('#menuClose'), scrim = $('#scrim');
    if (!btn || !menu) return;
    function open(on) {
      menu.hidden = !on;
      /* 9 Aug mobile review: the CSS opens this menu with .open
         (.mobmenu{transform:translateY(-100%)} .mobmenu.open{transform:none})
         but the port only toggled [hidden] - the menu unhid while still
         parked off-screen, so tapping Menu did nothing visible. */
      if (on) void menu.offsetWidth;
      menu.classList.toggle('open', on);
      /* round twelve-c: the menu no longer touches the shared scrim — it is a
         full-screen paper panel and needs no dimmer. Its old scrim.hidden
         toggling fought the drawer code's class-based protocol and stranded
         the veil. */
      btn.setAttribute('aria-expanded', String(on));
      if (on) { koScrollLock(); } else { koScrollUnlock(); }
      if (on) { var f = menu.querySelector('a,button'); if (f) f.focus(); }
    }
    btn.addEventListener('click', function () { open(menu.hidden); });
    if (close) close.addEventListener('click', function () { open(false); btn.focus(); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && !menu.hidden) { open(false); btn.focus(); }
    });
  })();

  /* ---------- product: option buttons drive the hidden variant select ---------- */
  (function () {
    var form = $('#ko-product-form');
    var sel  = $('#ko-variant-select');
    if (!form || !sel) return;

    var chosen = [];
    /* Was $$('.fopts', form) — but only the Frame group carries the fopts
       class; the Size group is plain .opts, so chosen[0] was never seeded
       and stayed a HOLE in the array. Array.every() skips holes, so
       variantFor() only ever checked the frame and matched the first size
       in the select. Land on ?variant=<76x76 Oak> and sync() silently
       rewrote the headline to 45,00, rewrote the URL to the 20x20 variant,
       and left the 76x76 row highlighted — the form would then add the
       wrong size to the bag. .opts matches both groups. */
    $$('.opts', form).forEach(function (group) {
      var i = parseInt(group.getAttribute('data-option-index'), 10);
      var on = group.querySelector('.fsw.on');
      chosen[i] = on ? on.getAttribute('data-val') : null;
    });

    /* The size rows carry a per-row price, rendered server side for the
       frame that was selected on load. Changing frame only replaceState()s
       the URL — no reload — so without this the rows would keep quoting the
       old frame while the headline moved. Repaint them from the variant
       select, which already carries data-price per variant. */
    var sizeGroup = null, sizeIdx = -1;
    $$('.opts', form).forEach(function (g) {
      if (!g.classList.contains('fopts')) {
        sizeGroup = g;
        sizeIdx = parseInt(g.getAttribute('data-option-index'), 10);
      }
    });

    function repaintRows() {
      if (!sizeGroup || sizeIdx < 0) return;
      var map = {};
      $$('option', sel).forEach(function (o) {
        var parts = o.textContent.trim().split(' / ').map(function (s) { return s.trim(); });
        for (var i = 0; i < chosen.length; i++) {
          if (i === sizeIdx) continue;
          if (chosen[i] != null && parts[i] !== chosen[i]) return;
        }
        var k = parts[sizeIdx];
        if (map[k] == null) map[k] = o.getAttribute('data-price');
      });
      $$('.fsw', sizeGroup).forEach(function (b) {
        var pp = b.querySelector('.pp');
        var v = b.getAttribute('data-val');
        if (pp && map[v]) pp.textContent = map[v];
      });
    }

    /* 14 Oct 2026 (Rareș, A of 13 Oct's finding 2): each frame button carries its own
       price at the chosen size, rendered server side for the size selected on load.
       Changing size only replaceState()s the URL, so the frame prices are repainted
       here from the variant select, the mirror of repaintRows() above. */
    function repaintFrames() {
      if (!frameGroup || FRAME_IDX < 0) return;
      var map = {};
      $$('option', sel).forEach(function (o) {
        var parts = o.textContent.trim().split(' / ').map(function (s) { return s.trim(); });
        for (var i = 0; i < chosen.length; i++) {
          if (i === FRAME_IDX) continue;
          if (chosen[i] != null && parts[i] !== chosen[i]) return;
        }
        var k = parts[FRAME_IDX];
        if (map[k] == null) map[k] = o.getAttribute('data-price');
      });
      $$('.fsw', frameGroup).forEach(function (b) {
        var pp = b.querySelector('.pp');
        var v = b.getAttribute('data-val');
        if (pp) pp.textContent = map[v] || '';
      });
    }

    function variantFor(vals) {
      var match = null;
      $$('option', sel).forEach(function (o) {
        if (match) return;
        var parts = o.textContent.trim().split(' / ').map(function (s) { return s.trim(); });
        var ok = vals.every(function (v, i) { return v == null || parts[i] === v; });
        if (ok) match = o;
      });
      return match;
    }

    /* 27 Aug: not every size exists in every frame. Framed A5 was withdrawn
       because the lab has no mockup scenes for it, and any future size can lose
       a frame for its own reasons. variantFor() returns null for those pairs and
       sync() used to return silently -- which left the previous variant selected,
       the previous price on screen and Add to bag armed. Someone could choose
       15 x 21 and Black, read the unframed price, and buy an unframed print
       believing it was framed.

       The size list is the real choice and every size exists unframed, so the
       frame is the axis that gets constrained: frames that do not exist in the
       chosen size are shown disabled, and picking a size that has no such frame
       falls back to No frame rather than leaving an impossible pair on screen. */
    var FRAME_IDX = -1;
    $$('.opts', form).forEach(function (g) {
      if (g.classList.contains('fopts')) FRAME_IDX = parseInt(g.getAttribute('data-option-index'), 10);
    });
    var frameGroup = form.querySelector('.opts.fopts');

    function frameAvailable(value) {
      if (FRAME_IDX < 0) return true;
      var probe = chosen.slice();
      probe[FRAME_IDX] = value;
      return !!variantFor(probe);
    }

    function refreshFrames() {
      if (!frameGroup) return;
      $$('.fsw', frameGroup).forEach(function (b) {
        var ok = frameAvailable(b.getAttribute('data-val'));
        b.classList.toggle('off', !ok);
        b.disabled = !ok;
        b.setAttribute('aria-disabled', ok ? 'false' : 'true');
        b.title = ok ? '' : 'Not made in this size';
      });
    }

    function fallbackFrame() {
      if (!frameGroup || FRAME_IDX < 0) return;
      if (frameAvailable(chosen[FRAME_IDX])) return;
      var pick = null;
      $$('.fsw', frameGroup).forEach(function (b) {
        var v = b.getAttribute('data-val');
        if (!pick && /^no frame$/i.test(v) && frameAvailable(v)) pick = v;
      });
      $$('.fsw', frameGroup).forEach(function (b) {
        var v = b.getAttribute('data-val');
        if (!pick && frameAvailable(v)) pick = v;
      });
      if (!pick) return;
      chosen[FRAME_IDX] = pick;
      $$('.fsw', frameGroup).forEach(function (x) {
        var on = x.getAttribute('data-val') === pick;
        x.classList.toggle('on', on);
        x.setAttribute('aria-pressed', String(on));
      });
    }

    function sync() {
      fallbackFrame();
      refreshFrames();
      var opt = variantFor(chosen);
      if (!opt) return;
      sel.value = opt.value;

      var price = $('[data-price]');
      if (price && opt.dataset.price) price.textContent = opt.dataset.price;

      var specSize = $('[data-spec-size]');
      if (specSize && opt.dataset.size) specSize.textContent = opt.dataset.size;

      var add = $('[data-add]');
      if (add) {
        var soldOut = opt.disabled;
        add.disabled = soldOut;
        add.textContent = soldOut ? (add.getAttribute('data-na') || 'Unavailable') : 'Add to bag';
        add.classList.toggle('na', soldOut);
      }

      if (history.replaceState) {
        var u = new URL(window.location.href);
        u.searchParams.set('variant', opt.value);
        history.replaceState({}, '', u);
      }

      repaintRows();
      repaintFrames();
    }

    form.addEventListener('click', function (e) {
      var b = e.target.closest('.fsw');
      if (!b) return;
      if (b.disabled || b.classList.contains('off')) return;
      var i = parseInt(b.getAttribute('data-opt'), 10);
      chosen[i] = b.getAttribute('data-val');
      $$('.fsw[data-opt="' + i + '"]', form).forEach(function (x) {
        var on = x === b;
        x.classList.toggle('on', on);
        x.setAttribute('aria-pressed', String(on));
      });
      sync();
      remember();
    });

    /* F59 (28 Aug, Rareș): size memory — size only, deliberately. The last
       size a visitor chose by hand follows them from print to print — stored
       only in this browser, applied only when the URL does not already name a
       variant (links from the wall tool and the archive keep their exact
       variant), and only where that size exists on this product. The frame is
       NOT remembered: every product opens unframed at its base price. It
       briefly remembered the frame too, and an inherited oak frame read as an
       expensive default (Rareș, 28 Aug). applyMemory also strips a leftover
       frame key from storage written by that earlier version. Plain DOM calls
       throughout — the $ helper does not resolve inside functions declared
       this late in the IIFE after minification, which cost an afternoon to
       learn. try/catch because storage can be blocked, and the page must
       render identically without it. */
    var MEMKEY = 'ko-pick';
    function eachEl(list, fn) { Array.prototype.forEach.call(list, fn); }
    function remember() {
      try {
        var out = {};
        var g = form.querySelector('.opts:not(.fopts)');
        if (g) {
          var i = parseInt(g.getAttribute('data-option-index'), 10);
          if (chosen[i] != null) out.s = chosen[i];
        }
        localStorage.setItem(MEMKEY, JSON.stringify(out));
      } catch (err) {}
    }
    function applyMemory() {
      try {
        if (new URL(window.location.href).searchParams.get('variant')) return;
        var m = JSON.parse(localStorage.getItem(MEMKEY) || 'null');
        if (!m) return;
        if (m.f) { delete m.f; localStorage.setItem(MEMKEY, JSON.stringify(m)); }
        var val = m.s;
        if (!val) return;
        var g = form.querySelector('.opts:not(.fopts)');
        if (!g) return;
        var b = null;
        eachEl(g.querySelectorAll('.fsw'), function (x) { if (!b && x.getAttribute('data-val') === val) b = x; });
        if (!b || b.disabled || b.classList.contains('off')) return;
        var i = parseInt(b.getAttribute('data-opt'), 10);
        chosen[i] = val;
        eachEl(form.querySelectorAll('.fsw[data-opt="' + i + '"]'), function (x) {
          var on = x === b;
          x.classList.toggle('on', on);
          x.setAttribute('aria-pressed', String(on));
        });
        refreshFrames();
      } catch (err) {}
    }
    applyMemory();
    sync();
  })();

  /* ---------- cart: quantity and remove ---------- */
  (function () {
    var wrap = $('.ko-cart');
    if (!wrap) return;

    /* F58. Every stepper click used to call window.location.reload() —
       /cart/change.js already returns the updated cart and the response was
       parsed and thrown away. Rebuilding the four server-rendered values by
       hand (line prices, discount rows, threshold note, subtotal) would mean
       reimplementing Liquid's money filter in JS on the one page where a
       wrong number is worst: this store renders EUR as \u20ac38,00, comma
       decimal. So ask Shopify to re-render the section instead — it returns
       the same Liquid output the server would have sent, already formatted.

       The section id is NOT 'main'. JSON templates generate
       'template--<theme id>__main', and that theme id changes every time the
       theme is duplicated — which happens here often. Hardcoding it would
       work today and silently fall back to reloading on the next duplicate,
       so read it off the DOM. */
    var host = wrap.closest('.shopify-section');
    var SECTION = host ? host.id.replace(/^shopify-section-/, '') : null;

    function swap(html) {
      if (!host) return false;
      var box = document.createElement('div');
      box.innerHTML = html;
      var fresh = box.querySelector('#' + CSS.escape(host.id)) || box.firstElementChild;
      if (!fresh) return false;
      host.innerHTML = fresh.innerHTML;
      return true;
    }

    function change(key, qty, revert) {
      fetch(window.KO.routes.cart_change, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty, sections: SECTION, sections_url: '/cart' })
      }).then(function (r) { return r.json(); })
        .then(function (cart) {
          $$('[data-cart-count]').forEach(function (n) { n.textContent = cart.item_count; });
          if (!(SECTION && cart.sections && cart.sections[SECTION] && swap(cart.sections[SECTION]))) {
            window.location.reload();   /* the old behaviour, kept as the fallback */
          } else {
            /* 5 Sept: keep keyboard focus on the row that was being edited */
            var again = document.querySelector('.ko-cart [data-key="' + key + '"] input[name="updates[]"]') || document.querySelector('.ko-cart input[name="updates[]"]');
            if (again && again.focus) again.focus();
          }
        })
        .catch(function () {
          /* input.value was set optimistically before the request. Without this
             the field keeps showing a quantity the server never accepted, and
             the next thing the customer does is check out against it. */
          if (revert) revert();
          toast('Could not update the bag');
        });
    }

    /* Delegated from document, not from wrap: swapping the section replaces
       .ko-cart entirely, which would take a listener bound to it along too. */
    document.addEventListener('click', function (e) {
      var row = e.target.closest('.ko-cart [data-key]');
      if (!row) return;
      var key = row.getAttribute('data-key');
      var input = row.querySelector('input[name="updates[]"]');

      var step = e.target.closest('[data-qty]');
      if (step && input) {
        var next = Math.max(0, parseInt(input.value, 10) + parseInt(step.getAttribute('data-qty'), 10));
        var prev = input.value;
        input.value = next;
        change(key, next, function () { input.value = prev; });
        return;
      }
      if (e.target.closest('[data-remove]')) { change(key, 0); }
    });
  })();

  /* ---------- add to bag, without leaving the page ---------- */
  (function () {
    var form = $('#ko-product-form');
    if (!form) return;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = $('[data-add]', form);
      if (btn) { btn.disabled = true; btn.textContent = 'Adding'; }

      fetch(window.KO.routes.cart_add + '.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
        .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, d: d }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.d.description || 'Could not add');
          toast('Added to bag');
          return fetch(window.KO.routes.cart + '.js').then(function (r) { return r.json(); });
        })
        .then(function (cart) {
          $$('[data-cart-count]').forEach(function (n) { n.textContent = cart.item_count; });
          /* 21 Oct (deploy 1): open the bag after a successful add, so the shopper sees what went in. */
          document.dispatchEvent(new CustomEvent('ko:cart-changed', { detail: { openBag: true } }));
          /* F59. This called toast() a SECOND time a few hundred ms after the
             first, and toast() overwrites textContent and restarts its timer —
             so "Added to bag" was wiped out the moment /cart.js came back. The
             one message the customer actually needs was the one they never got
             to finish reading. Keep the immediate toast (it covers the network
             latency), then EXTEND it rather than replace it. */
          var short = window.KO.wallMinItems - cart.item_count;
          if (short > 0 && cart.item_count > 0) {
            toast('Added \u2014 ' + short + ' more and the set takes ' + window.KO.wallDiscount + '% off');
          }
        })
        .catch(function (err) { toast(err.message || 'Could not add'); })
        .finally(function () { if (btn) { btn.disabled = false; btn.textContent = 'Add to bag'; } });
    });
  })();

  /* ============================================================
     The journey — scroll-driven canvas film
     Ported from the prototype. The stage sticks, the page scrolls, and
     scroll position picks the frame. It is not a timed sequence: the
     parallax IS the mechanism, not decoration on top of it.
     ============================================================ */
  (function () {
    var journey = document.getElementById('journey');
    var stage   = document.getElementById('stage');
    var cv      = document.getElementById('cv');
    if (!journey || !stage || !cv) return;

    var ctx = cv.getContext('2d');
    var reveal = document.getElementById('heroReveal');
    var fgOpen = document.getElementById('fgOpen');
    var fgArt  = document.getElementById('fgArt');
    var fgPrev = document.getElementById('fgPrev');
    var fgNext = document.getElementById('fgNext');
    var fgPlac = document.getElementById('fgPlac');
    var lbar   = document.getElementById('lbar');
    var loader = document.getElementById('loader');
    var skip   = document.getElementById('skipFilm');

    function readJSON(id) {
      var el = document.getElementById(id);
      if (!el) return [];
      try { return JSON.parse(el.textContent) || []; } catch (e) { return []; }
    }
    var SRC = readJSON('ko-frames');
    /* 23 Aug (Rareș, phone speed): under 700px take the half-width frame set.
       Same film, roughly 57% fewer bytes. Guarded — only swaps on a complete list. */
    if (window.innerWidth < 700) { var SRCM = readJSON('ko-frames-m'); if (SRCM.length === SRC.length) SRC = SRCM; }
    var GAL = readJSON('ko-gallery');
    if (!SRC.length) return;

    var VH   = (parseFloat(journey.dataset.vh) || 12) / 100;
    /* 15 Aug (phone review): halve the scroll-per-frame on phones — the
       journey was 676vh of thumb travel; 388vh reads faster and smoother. */
    if (window.innerWidth < 700) VH = VH / 2;
    var ON   = (parseFloat(journey.dataset.on)  || 99) / 100;
    var OFF  = (parseFloat(journey.dataset.off) || 96) / 100;
    var OPEN = (journey.dataset.open || '0.5,0.33,0.405,0.49').split(',').map(Number);
    var PLAC = (journey.dataset.plac || '0.82,0.58').split(',').map(Number);

    var IMGS = [], loaded = 0, current = -1, ticking = false;
    var shown = false, cur = 0;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    journey.style.height = (100 + SRC.length * VH * 100) + 'vh';

    /* Two defects lived in this block, both silent.

       1. `if (loaded === 1) paint(0)` fired for whichever of the 48 frames
          finished FIRST, which is not necessarily frame 01. When it wasn't,
          paint(0) hit its own !img.complete guard, returned, and nothing
          repainted — paint(0) appears once in this file, and the only other
          routes into paint() are the scroll and resize listeners. .stage is
          #0E0F12, so the hero sat BLACK until the visitor moved. A load-order
          race, which is why it never reproduced on a warm cache: the frames
          usually arrive close to request order and frame 01 usually wins.
          This is the most likely explanation for the homepage coming up black
          for 14 seconds on 9 Aug. Now: size() still runs on the first arrival
          (the canvas needs dimensions early), but the first PAINT is bound to
          frame 0 specifically, whenever it lands.

       2. There was no onerror. loaded could never reach SRC.length, so
          `loader.style.opacity = 0` never ran and the progress bar stayed on
          the hero for the whole session — no timeout, no fallback. A failed
          frame now counts toward the total and announces itself, the way the
          wall tool's overlapCheck does. */
    function frameDone() {
      loaded++;
      if (lbar) lbar.style.transform = 'scaleX(' + (loaded / SRC.length) + ')';
      if (loaded === 1) size();
      if (loaded === SRC.length && loader) loader.style.opacity = 0;
    }

    /* 22 Aug: staged frame loading. All 48 at once fought the rest of the
       page for bandwidth on phones. Now: frame 0 first (high priority), then
       every 3rd frame so the film is scrubbable early (paintF already falls
       back to the nearest earlier loaded frame), then the gaps — never more
       than 4 requests in flight, so product images get through. */
    var QUEUE = [0];
    for (var qi = 3; qi < SRC.length; qi += 3) QUEUE.push(qi);
    for (var qj = 1; qj < SRC.length; qj++) if (qj % 3 !== 0) QUEUE.push(qj);
    var qPos = 0, inFlight = 0;
    function pump() {
      while (inFlight < 4 && qPos < QUEUE.length) {
        (function (i) {
          inFlight++;
          var im = new Image();
          im.decoding = 'async';
          try { im.fetchPriority = (i === 0) ? 'high' : 'low'; } catch (e) {}
          im.onload = function () {
            inFlight--; frameDone();
            if (i === 0) paint(0);      /* not "whichever arrived first" */
            pump();
          };
          im.onerror = function () {
            console.warn('[film] frame ' + (i + 1) + ' of ' + SRC.length + ' failed to load: ' + SRC[i]);
            inFlight--; frameDone(); pump();
          };
          im.src = SRC[i];
          IMGS[i] = im;
        })(QUEUE[qPos++]);
      }
    }
    pump();

    function size() {
      var dpr = Math.min(window.devicePixelRatio || 1, window.innerWidth < 700 ? 1.5 : 2);
      cv.width  = Math.round(stage.clientWidth  * dpr);
      cv.height = Math.round(stage.clientHeight * dpr);
      cv.style.width = '100%';
      cv.style.height = '100%';
      current = -1; lastI = -1;
    }

    /* round seventeen (Rareș): mobile smoothness without new assets. Two
       techniques, zero bytes added: (1) the scroll input is LERPED each rAF
       so momentum scrolling's coarse jumps become motion; (2) paintF
       CROSS-FADES adjacent frames (frame i, then i+1 at the fractional
       alpha), so the 48 steps read as continuous. */
    var lastI = -1, lastF = 0;
    function fready(k) { var im = IMGS[k]; return im && im.complete && im.naturalWidth; }
    function paintF(x) {
      var N = SRC.length;
      var i = Math.max(0, Math.min(N - 1, Math.floor(x)));
      var f = x - i;
      /* cold cache: nearest earlier loaded frame, no fade */
      while (i > 0 && !fready(i)) { i--; f = 0; }
      if (!fready(i)) return;
      if (i === lastI && Math.abs(f - lastF) < 0.01) return;
      lastI = i; lastF = f; current = i;
      var cw = cv.width, ch = cv.height;
      function draw(im, alpha) {
        var sc = Math.max(cw / im.naturalWidth, ch / im.naturalHeight);
        var w = im.naturalWidth * sc, h = im.naturalHeight * sc;
        ctx.globalAlpha = alpha;
        ctx.drawImage(im, (cw - w) / 2, (ch - h) / 2, w, h);
      }
      draw(IMGS[i], 1);
      if (f > 0.02 && i + 1 < N && fready(i + 1)) draw(IMGS[i + 1], f);
      ctx.globalAlpha = 1;
    }
    function paint(i) { paintF(i); }

    /* the rect the last frame actually occupies once cover-cropped */
    function coverGeom() {
      var img = IMGS[SRC.length - 1];
      var cw = stage.clientWidth, ch = stage.clientHeight;
      if (img && img.complete && img.naturalWidth) {
        var sc = Math.max(cw / img.naturalWidth, ch / img.naturalHeight);
        var w = img.naturalWidth * sc, h = img.naturalHeight * sc;
        return { ox: (cw - w) / 2, oy: (ch - h) / 2, w: w, h: h };
      }
      return { ox: 0, oy: 0, w: cw, h: ch };
    }

    function layout() {
      var g = coverGeom();
      var w = OPEN[2] * g.w, h = OPEN[3] * g.h;
      var x = g.ox + OPEN[0] * g.w - w / 2;
      var y = g.oy + OPEN[1] * g.h - h / 2;

      fgOpen.style.left = x + 'px';
      fgOpen.style.top = y + 'px';
      fgOpen.style.width = w + 'px';
      fgOpen.style.height = h + 'px';

      fgPrev.style.left = Math.max(4, x - 52) + 'px';
      fgPrev.style.top = (y + h / 2 - 22) + 'px';
      fgNext.style.left = Math.min(stage.clientWidth - 48, x + w + 8) + 'px';
      fgNext.style.top = (y + h / 2 - 22) + 'px';

      fgPlac.style.left = (g.ox + PLAC[0] * g.w) + 'px';
      fgPlac.style.top  = (g.oy + PLAC[1] * g.h) + 'px';
      fgPlac.style.transform = 'translate(-50%,-50%)';

      art();
    }

    /* matching proportions fill the opening; anything else gets a
       rendered passepartout, true aspect on the mat */
    function art() {
      var it = GAL[cur];
      if (!it) return;
      var ow = fgOpen.clientWidth, oh = fgOpen.clientHeight;
      var openAR = ow / oh, ar = it.ar || 0.714;
      var fills = Math.abs(openAR - ar) < 0.04;
      var w, h;
      if (fills) { w = ow; h = oh; }
      else if (ar > openAR) { w = ow * 0.86; h = w / ar; }
      else { h = oh * 0.86; w = h * ar; }

      fgArt.style.width = Math.round(w) + 'px';
      fgArt.style.height = Math.round(h) + 'px';
      fgArt.style.left = Math.round((ow - w) / 2) + 'px';
      fgArt.style.top = Math.round((oh - h) / 2) + 'px';
      fgArt.style.background = it.img ? '#fff url("' + it.img + '") center/contain no-repeat' : '#fff';
      fgOpen.style.background = fills ? 'transparent' : '#FBFAF7';

      fgPlac.innerHTML = '<span class="pt">' + it.title + '</span>' +
        '<span class="pa">' + (it.label || '') + (it.no ? ' · ' + it.no : '') + '</span>' +
        '<span class="pp">from &euro;' + it.price + '</span>';
      fgPlac.setAttribute('href', it.url || '#');
    }

    function reveal_at(p) {
      if (!reveal) return;
      if (!shown && p >= ON) shown = true;
      else if (shown && p < OFF) shown = false;

      var vis = shown && GAL.length > 0;
      reveal.style.visibility = vis ? 'visible' : 'hidden';
      reveal.style.pointerEvents = vis ? 'auto' : 'none';
      if (skip) skip.style.opacity = vis ? 0 : 1;
      if (!vis) return;

      layout();
      fgOpen.style.opacity = 1;
      fgPrev.style.opacity = 1;
      fgNext.style.opacity = 1;
      fgPlac.style.opacity = 1;
    }

    var pT = 0, pS = 0;
    function frame() {
      ticking = false;
      var stageH = stage.clientHeight;
      var total = Math.max(1, journey.offsetHeight - stageH);
      pT = Math.min(1, Math.max(0, -journey.getBoundingClientRect().top / total));
      document.documentElement.setAttribute('data-hero', pT < 0.995 ? 'on' : 'off');
    }

    /* 9 Aug mobile review: the film advanced only on scroll EVENTS, which
       mobile momentum scrolling delivers sparsely - frames jumped in steps
       and read as glitch. A continuous rAF loop samples scroll once per
       display frame; paint() no-ops while the frame index is unchanged. */
    /* round eighteen-b (Rareș): stopping mid-scroll used to REST on a
       cross-faded blend of two frames — a ghost. While the finger moves the
       film blends; once the input has been still for ~12 ticks (~200ms) the
       display eases onto the NEAREST WHOLE FRAME, so the resting image is
       always a single crisp frame. Resuming scroll unsnaps instantly. */
    var idleTicks = 0, lastPT = -1;
    function loop() {
      if (journey.getBoundingClientRect().bottom > -8) {
        frame();
        if (Math.abs(pT - lastPT) < 0.000001) { idleTicks++; } else { idleTicks = 0; }
        lastPT = pT;
        var target = pT;
        if (idleTicks > 12) {
          var N1 = Math.max(1, SRC.length - 1);
          target = Math.round(pT * N1) / N1;
        }
        pS += (target - pS) * 0.16;
        if (Math.abs(target - pS) < 0.0005) pS = target;
        paintF(pS * (SRC.length - 1));
        reveal_at(pS);
      }
      requestAnimationFrame(loop);
    }

    if (fgNext) fgNext.addEventListener('click', function (e) { e.preventDefault(); cur = (cur + 1) % GAL.length; art(); });
    if (fgPrev) fgPrev.addEventListener('click', function (e) { e.preventDefault(); cur = (cur - 1 + GAL.length) % GAL.length; art(); });

    window.addEventListener('resize', function () { size(); frame(); });

    if (reduced) {
      journey.style.height = 'auto';
      stage.style.position = 'static';
      document.documentElement.setAttribute('data-hero', 'off');
      paint(SRC.length - 1);
      shown = true; reveal_at(1);
    } else {
      frame();
      requestAnimationFrame(loop);
    }
  })();

  /* ---------- how big, exactly — the scale drawing ---------- */
  (function () {
    var host = document.getElementById('homeScale');
    var chips = document.getElementById('homeSizes');
    if (!host || !chips) return;

    var raw = document.getElementById('ko-sizes');
    /* The Liquid setting normally wins; this is only the fallback. It used to
       carry 50x50 and 70x39, neither of which exists in the catalogue — the same
       placeholder list that was removed from home-scale.liquid's schema default
       at 19:24. Two copies of one list is how every drift defect here started. */
    var sizes = [[50, 70], [70, 50], [45, 60], [30, 40]];
    if (raw) {
      try {
        var parsed = JSON.parse(raw.textContent);
        if (typeof parsed === 'string' && parsed.trim()) {
          sizes = parsed.split(',').map(function (s) {
            var d = s.trim().toLowerCase().split('x').map(Number);
            return (d.length === 2 && d[0] && d[1]) ? d : null;
          }).filter(Boolean);
        }
      } catch (e) {}
    }
    if (!sizes.length) return;

    function scaleSVG(pw, ph, rw, rh) {
      var K = 0.82, sofaW = 200 * K, sofaH = 62 * K, cx = 160, floor = 175;
      var wA = (pw || 50) * K, hA = (ph || 70) * K;
      var wB = (rw || 30) * K, hB = (rh || 40) * K;
      var top = floor - sofaH - 14;
      return '<svg class="scale" viewBox="0 0 320 200" role="img" aria-label="Print size against a two-seater sofa">' +
        '<line class="thin" x1="12" y1="' + floor + '" x2="308" y2="' + floor + '"/>' +
        '<rect class="ln" x="' + (cx - sofaW / 2) + '" y="' + (floor - sofaH) + '" width="' + sofaW + '" height="' + sofaH + '" rx="3"/>' +
        '<line class="thin" x1="' + (cx - sofaW / 2 + 18) + '" y1="' + (floor - sofaH) + '" x2="' + (cx - sofaW / 2 + 18) + '" y2="' + floor + '"/>' +
        '<line class="thin" x1="' + (cx + sofaW / 2 - 18) + '" y1="' + (floor - sofaH) + '" x2="' + (cx + sofaW / 2 - 18) + '" y2="' + floor + '"/>' +
        '<rect class="active" x="' + (cx - wA - 14) + '" y="' + (top - hA) + '" width="' + wA + '" height="' + hA + '"/>' +
        '<rect class="box" x="' + (cx - wA - 14) + '" y="' + (top - hA) + '" width="' + wA + '" height="' + hA + '"/>' +
        '<text x="' + (cx - wA - 14) + '" y="' + (top - hA - 6) + '">' + (pw || 50) + ' x ' + (ph || 70) + '</text>' +
        '<rect class="fill" x="' + (cx + 14) + '" y="' + (top - hB) + '" width="' + wB + '" height="' + hB + '"/>' +
        '<rect class="box" x="' + (cx + 14) + '" y="' + (top - hB) + '" width="' + wB + '" height="' + hB + '"/>' +
        '<text x="' + (cx + 14) + '" y="' + (top - hB - 6) + '">' + (rw || 30) + ' x ' + (rh || 40) + '</text>' +
        '<text x="12" y="192">Two-seater, 200 cm — to scale</text></svg>';
    }

    chips.innerHTML = sizes.map(function (s, i) {
      return '<button type="button" class="chip" aria-pressed="' + (i === 0) + '" data-s="' + s[0] + 'x' + s[1] + '">' +
             s[0] + ' × ' + s[1] + '</button>';
    }).join('');

    function draw(s) { host.innerHTML = scaleSVG(s[0], s[1], 21, 29); }

    chips.addEventListener('click', function (e) {
      var b = e.target.closest('[data-s]');
      if (!b) return;
      chips.querySelectorAll('.chip').forEach(function (x) {
        x.setAttribute('aria-pressed', String(x === b));
      });
      draw(b.dataset.s.split('x').map(Number));
    });

    draw(sizes[0]);
  })();


  /* ---------- archive: show me one + sort ---------- */
  (function () {
    var one = document.getElementById('showOne');
    if (one) one.addEventListener('click', function () {
      var cards = $$('.agrid a.acard[href]');
      if (cards.length) window.location.href = cards[Math.floor(Math.random() * cards.length)].getAttribute('href');
    });
    if (one && /[?&]one=1(?:&|$)/.test(location.search)) { one.click(); } /* 6 Sept: the Where-to-start page's last door */
    var sort = document.getElementById('sort');
    if (sort) sort.addEventListener('change', function () {
      if (sort.value.indexOf('year-') === 0) return; /* handled client-side (KOSWEEP2) */
      var u = new URL(window.location.href);
      u.searchParams.set('sort_by', sort.value);
      window.location.href = u.pathname + '?' + u.searchParams.toString();
    });
  })();

  /* ---------- archive: say that Enter searches ---------- */
  /* B6. Typing in the archive toolbar did nothing until Enter: all 98 prints
     stayed on screen and the count line kept saying "98 prints", so the box
     read as broken rather than as not-yet-submitted. routes.predictive is
     passed to the front end and never used; a real type-ahead panel is a
     design decision for Rares, not something to invent here. This is the
     honest minimum: the count line says what to do while you are typing, and
     puts itself back if you clear the field. No filtering, because filtering
     only the 24 rendered cards out of 98 would say "no matches" when there
     are matches — worse than silence. */
  (function () {
    var q = $('#q'), count = $('#resCount');
    if (!q || !count) return;
    var original = count.textContent;
    q.addEventListener('input', function () {
      var typed = q.value.trim();
      count.textContent = typed ? 'Press Enter to search for \u201C' + typed + '\u201D' : original;
    });
    q.form && q.form.addEventListener('submit', function () {
      count.textContent = 'Searching\u2026';
      /* 3 Sept: the sort select shares this form, so every search carried
         sort_by=best-selling, which is arbitrary with no sales yet. Leave it
         out and Shopify ranks the results by relevance. */
      var s = q.form.querySelector('select[name="sort_by"]');
      if (s) s.disabled = true;
    });
  })();

  window.KOtoast = toast;
})();


/* ============================================================
   Drawers, buy bar and the noted list — built 9 Aug 2026,
   approved by Rareș; ported from the prototype whose CSS has
   been waiting in kommon-base.css since the original port.
   ============================================================ */
(function KOWIRE() {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var scrim = $('#scrim');

  /* ---------- shared layer plumbing (the mobile menu keeps its own) ---------- */
  function anyOpen() { return $$('.drawer.open').length > 0; }
  var lastOpener = null; /* 5 Sept: the drawers declare aria-modal; move focus in on open and back on close, as the mobile menu does */
  function openLayer(el) {
    if (!el || !scrim) return;
    $$('.drawer.open').forEach(function (d) { if (d !== el) d.classList.remove('open'); });
    scrim.hidden = false;
    void scrim.offsetWidth; /* force a reflow so the transition runs; rAF is unreliable here */
    scrim.classList.add('open');
    el.classList.add('open');
    koScrollLock();
    if (!anyOpen() || !lastOpener) lastOpener = document.activeElement;
    $$('.drawer').forEach(function (d) { d.inert = (d !== el); }); /* inert: out of the tab order and the accessibility tree while closed, whatever the transition does */
    var first = el.querySelector('[data-drawer-close], button, a[href], input');
    if (first && first.focus) first.focus();
  }
  function closeLayers() {
    if (!anyOpen()) return;
    $$('.drawer.open').forEach(function (d) { d.classList.remove('open'); });
    $$('.drawer').forEach(function (d) { d.inert = true; });
    if (scrim) {
      scrim.classList.remove('open');
      setTimeout(function () { if (!anyOpen()) scrim.hidden = true; }, 360);
    }
    koScrollUnlock();
    if (lastOpener && lastOpener.focus && document.contains(lastOpener)) lastOpener.focus();
    lastOpener = null;
  }
  $$('.drawer').forEach(function (d) { d.inert = !d.classList.contains('open'); }); /* 5 Sept: closed drawers start inert */
  if (scrim) scrim.addEventListener('click', closeLayers);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeLayers(); });
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-drawer-close]')) closeLayers();
  });

  /* ---------- the bag drawer ---------- */
  var drawer = $('#koDrawer');
  function swapDrawer(html) {
    if (!html || !drawer) return;
    var t = document.createElement('div');
    t.innerHTML = html;
    var fresh = t.querySelector('.drawer');
    if (fresh) drawer.innerHTML = fresh.innerHTML;
    /* 5 Sept: the swap replaces whatever had focus; if the drawer is open and focus fell out, put it on the first control */
    if (drawer.classList.contains('open') && !drawer.contains(document.activeElement)) {
      var f = drawer.querySelector('[data-drawer-close], button, a[href], input');
      if (f && f.focus) f.focus();
    }
  }
  function refreshDrawer() {
    return fetch('/?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (j) { swapDrawer(j['cart-drawer']); })
      .catch(function () {});
  }
  /* 3 Sept: the add-to-bag handler only updated the count, so the first tap on
     Bag opened the drawer on stale markup (often the empty state) until the
     refresh landed. Refresh in the background whenever the cart changes. */
  document.addEventListener('ko:cart-changed', function (e) {
    var p = refreshDrawer();
    /* 21 Oct (deploy 1): after Add to bag, open the drawer once the fresh markup is in; not on the bag page. */
    if (e && e.detail && e.detail.openBag && drawer && document.body.className.indexOf('tpl-cart') < 0) {
      p.then(function () { openLayer(drawer); });
    }
  });

  /* deploy 3, 28 Oct 2026 (his A): back from "Email me this bag". Shopify's contact form posts to /contact and returns
     to this page with ?contact_posted=true and the form's id as the hash (the fragment survives the redirect). The hash
     guard keeps the contact page's own form, whose id is contact_form, from opening the bag. Every bag-email block on
     the page becomes the sent line; when it was the drawer's form, the drawer opens on fresh markup. */
  if (/[?&]contact_posted=true(?:&|$)/.test(location.search) && /^#ko-bagmail-(drawer|cart)$/.test(location.hash)) {
    var bagSent = function () {
      $$('.bagmail').forEach(function (d) {
        var p = document.createElement('p');
        p.className = 'bagmail-ok mono';
        p.textContent = 'On its way. Allow fifteen minutes.';
        d.parentNode.replaceChild(p, d);
      });
    };
    bagSent();
    if (location.hash === '#ko-bagmail-drawer' && drawer && document.body.className.indexOf('tpl-cart') < 0) {
      refreshDrawer().then(function () { bagSent(); openLayer(drawer); });
    } else {
      refreshDrawer().then(bagSent);
    }
  }
  document.addEventListener('click', function (e) {
    var a = e.target.closest('.cartbtn');
    if (!a || !drawer) return;
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    if (document.body.className.indexOf('tpl-cart') > -1) return; /* already on the bag page */
    e.preventDefault();
    refreshDrawer();
    openLayer(drawer);
  });

  /* steppers — delegated on document so the section swap cannot orphan them */
  var pending = false;
  document.addEventListener('click', function (e) {
    var b = e.target.closest('#koDrawer [data-dqty]');
    if (!b || pending) return;
    var qtyEl = b.parentElement.querySelector('span');
    var qty = parseInt(qtyEl && qtyEl.textContent, 10) || 0;
    var next = Math.max(0, qty + parseInt(b.getAttribute('data-dqty'), 10));
    var stepKey = b.getAttribute('data-key'), stepDir = b.getAttribute('data-dqty');
    pending = true;
    b.disabled = true;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: stepKey, quantity: next, sections: 'cart-drawer' })
    })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        var c = $('[data-cart-count]');
        if (c && typeof j.item_count === 'number') c.textContent = j.item_count;
        if (j.sections) swapDrawer(j.sections['cart-drawer']);
        /* 5 Sept: the swap destroyed the focused button; put focus back on its successor, or on Close */
        var again = drawer.querySelector('[data-key="' + stepKey + '"][data-dqty="' + stepDir + '"]') || drawer.querySelector('[data-drawer-close]');
        if (again && again.focus) again.focus();
      })
      .catch(function () {})
      .then(function () { pending = false; });
  });

  /* ---------- noted: a saved list, invisible until used ----------
     Device-local by design, matching the prototype: localStorage only,
     no account, nothing leaves the browser. Prices are stored as the
     server-formatted string captured at noting time — no money
     arithmetic ever happens in JS (the pass-30 rule). */
  var KEY = 'ko:noted';
  function load() { try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; } }
  function save(list) { try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {} }
  function isNoted(h) { return load().some(function (x) { return x.h === h; }); }

  var notedBtn = $('#notedBtn');
  function renderList(list) {
    var host = $('#nitems');
    if (!host) return;
    var nf = $('#ndfoot');
    if (nf) nf.hidden = !list.length; /* round thirteen: the wall bridge shows only when there is something to hang */
    host.textContent = '';
    if (!list.length) {
      var p = document.createElement('p');
      p.className = 'dempty';
      p.textContent = 'Nothing noted yet. The small \u2661 on any print keeps it here while you decide.';
      host.appendChild(p);
      return;
    }
    list.forEach(function (x) {
      var r = document.createElement('div');
      r.className = 'ditem';
      var a = document.createElement('a');
      a.href = '/products/' + x.h;
      if (x.img) {
        var im = document.createElement('img');
        im.src = x.img; im.alt = x.t; im.loading = 'lazy';
        a.appendChild(im);
      }
      var mid = document.createElement('div');
      var no = document.createElement('span'); no.className = 's'; no.textContent = x.n || '';
      var tt = document.createElement('a'); tt.className = 't'; tt.href = '/products/' + x.h; tt.textContent = x.t;
      tt.style.display = 'block'; tt.style.color = 'inherit';
      var pr = document.createElement('span'); pr.className = 's'; pr.textContent = x.p || '';
      mid.appendChild(no); mid.appendChild(tt); mid.appendChild(pr);
      var rm = document.createElement('button');
      rm.type = 'button'; rm.className = 'cardnote on';
      rm.setAttribute('data-note-handle', x.h);
      rm.setAttribute('aria-label', 'Remove from noted');
      rm.textContent = '✕';
      r.appendChild(a); r.appendChild(mid); r.appendChild(rm);
      host.appendChild(r);
    });
  }
  function paint() {
    var list = load();
    if (notedBtn) {
      notedBtn.classList.toggle('has', list.length > 0);
      var c = $('#notedCount');
      if (c) c.textContent = list.length;
    }
    var pdp = $('#pdpNote');
    if (pdp) {
      var pdpOn = isNoted(pdp.getAttribute('data-note-handle'));
      pdp.innerHTML = pdpOn ? 'Noted \u2665' : 'Note this print <span class="nplus">\u2661</span>';
      pdp.setAttribute('aria-pressed', pdpOn ? 'true' : 'false');
    }
    $$('.cardnote').forEach(function (b) {
      if (b.closest('#nitems')) return; /* list rows manage themselves */
      var on = isNoted(b.getAttribute('data-note-handle'));
      b.classList.toggle('on', on);
      b.textContent = on ? '\u2665' : '\u2661'; /* round eighteen: hearts — the + read as ambiguous */
      b.setAttribute('aria-pressed', on ? 'true' : 'false'); /* 5 Sept: announce the state */
      var t = b.getAttribute('data-note-title');
      if (t) b.setAttribute('aria-label', (on ? 'Noted: ' : 'Note ') + t);
    });
    renderList(list);
  }
  function toggleNote(el) {
    var h = el.getAttribute('data-note-handle');
    if (!h) return;
    var list = load();
    if (list.some(function (x) { return x.h === h; })) {
      list = list.filter(function (x) { return x.h !== h; });
    } else {
      list.push({
        h: h,
        t: el.getAttribute('data-note-title') || '',
        n: el.getAttribute('data-note-no') || '',
        img: el.getAttribute('data-note-img') || '',
        p: el.getAttribute('data-note-price') || ''
      });
    }
    save(list);
    paint();
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('.cardnote, #pdpNote');
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    toggleNote(b);
  }, true);
  if (notedBtn) notedBtn.addEventListener('click', function () { paint(); openLayer($('#ndrawer')); });
  paint();
  /* 27 Aug: the archive appends cards as you browse; repaint their hearts. */
  document.addEventListener('ko:cards-added', paint);
})();


/* ============================================================
   Sweep additions, 15 Aug 2026 (his phone review, round two):
   tucking mobile header, chip-row fade affordances, and a year
   sort that sorts by the artwork year instead of upload date.
   ============================================================ */
(function KOSWEEP2() {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- mobile: header tucks away on scroll-down, returns on scroll-up
     (15 Aug, his report: "the header takes up quite a bit of space") ---------- */
  (function () {
    var mq = window.matchMedia('(max-width: 899px)');
    var lastY = window.scrollY || 0, tucked = false;
    function setTuck(on) {
      if (tucked === on) return;
      tucked = on;
      document.documentElement.setAttribute('data-tuck', on ? '1' : '0');
    }
    window.addEventListener('scroll', function () {
      if (!mq.matches) { setTuck(false); return; }
      var y = window.scrollY || 0;
      if (y < 120 || y < lastY - 6) setTuck(false);
      else if (y > lastY + 6) setTuck(true);
      lastY = y;
    }, { passive: true });
  })();

  /* ---------- chip rows: fade edges say "there is more" (his report: no hint
     the row scrolls). Fades appear only on the side that has more. ---------- */
  /* 15 Aug, second round: Rareș found the fades too subtle — arrows, his
     original instinct. Small bordered ‹ › flanking the row, shown only on the
     side that has more, clickable; the fades stay as the underlay. */
  $$('.chips').forEach(function (c) {
    var wrap = document.createElement('div');
    wrap.className = 'chipwrap';
    c.parentNode.insertBefore(wrap, c);
    wrap.appendChild(c);
    var al = document.createElement('button');
    al.type = 'button'; al.className = 'chiparrow l'; al.textContent = '\u2039';
    al.setAttribute('aria-label', 'Scroll back');
    var ar = document.createElement('button');
    ar.type = 'button'; ar.className = 'chiparrow r'; ar.textContent = '\u203a';
    ar.setAttribute('aria-label', 'Scroll for more');
    wrap.appendChild(al); wrap.appendChild(ar);
    function judge() {
      var canL = c.scrollLeft > 4;
      var canR = c.scrollLeft + c.clientWidth < c.scrollWidth - 4;
      c.classList.toggle('fade-l', canL);
      c.classList.toggle('fade-r', canR);
      al.hidden = !canL;
      ar.hidden = !canR;
      /* 15 Aug round five: size from a VISIBLE chip (mode classes hide sets)
         and pin the arrows to the chips row's actual top edge — the panel's
         margin had left them 4px high. */
      var ch = null, allc = c.querySelectorAll('.chip');
      for (var k = 0; k < allc.length; k++) { if (allc[k].offsetHeight) { ch = allc[k]; break; } }
      if (ch) { al.style.height = ch.offsetHeight + 'px'; ar.style.height = ch.offsetHeight + 'px'; }
      al.style.top = c.offsetTop + 'px'; ar.style.top = c.offsetTop + 'px';
    }
    /* not scrollBy smooth — its rAF animation is unreliable in some contexts */
    al.addEventListener('click', function () { c.scrollLeft -= c.clientWidth * 0.7; });
    ar.addEventListener('click', function () { c.scrollLeft += c.clientWidth * 0.7; });
    c.addEventListener('scroll', function () { setTimeout(judge, 60); }, { passive: true });
    window.addEventListener('resize', judge);
    judge();
  });

  /* ---------- the year sort, made real ----------
     "Year · oldest/newest" used to map to created-* — the date the product was
     UPLOADED. Shopify cannot sort by metafield, so this gathers every page of
     the collection once, reads each card's data-year (kom.year), and reorders
     the grid client-side. Missing years sort last in either direction. */
  (function () {
    var sort = $('#sort'), grid = $('#agrid'), count = $('#resCount');
    if (!sort || !grid) return;
    var cache = null;
    function yearOf(el) {
      var m = String(el.getAttribute('data-year') || '').match(/\d{3,4}/);
      return m ? parseInt(m[0], 10) : null;
    }
    function gather() {
      if (cache) return Promise.resolve(cache);
      var base = window.location.pathname;
      var seen = {}, cards = [];
      function page(n) {
        /* 29 Aug: was 8 pages — 192 of 422 prints. The copy says "Gathering the whole
         archive", and it was quietly sorting less than half of it. 20 covers 480. */
      if (n > 20) return Promise.resolve();
        return fetch(base + '?page=' + n).then(function (r) { return r.text(); }).then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var found = doc.querySelectorAll('#agrid .acard');
          if (!found.length) return;
          var fresh = 0;
          Array.prototype.forEach.call(found, function (a) {
            var h = a.getAttribute('href');
            if (!seen[h]) { seen[h] = 1; cards.push(document.importNode(a, true)); fresh++; }
          });
          if (fresh > 0) return page(n + 1);
        });
      }
      return page(1).then(function () { cache = cards; return cards; });
    }
    sort.addEventListener('change', function () {
      if (sort.value.indexOf('year-') !== 0) return;
      var dir = sort.value === 'year-ascending' ? 1 : -1;
      if (count) count.textContent = 'Gathering the whole Archive…';
      gather().then(function (cards) {
        var sorted = cards.slice().sort(function (a, b) {
          var ya = yearOf(a), yb = yearOf(b);
          if (ya === null && yb === null) return 0;
          if (ya === null) return 1;
          if (yb === null) return -1;
          return (ya - yb) * dir;
        });
        grid.textContent = '';
        sorted.forEach(function (c) { grid.appendChild(c); });
        var lw = $('#loadWrap');
        if (lw) lw.hidden = true;
        if (count) count.textContent = sorted.length + ' prints · by date made';
      });
    });
  })();
})();


/* 15 Aug round four: fixed facet buttons — labels hold their line, the open
   set appears below as its own chip row (arrows come from the shared chips
   enhancement above). One open at a time. */
(function () {
  'use strict';
  var btns = Array.prototype.slice.call(document.querySelectorAll('.facetbtn'));
  var panel = document.getElementById('facetPanel');
  if (!btns.length || !panel) return;
  btns.forEach(function (b) {
    b.addEventListener('click', function () {
      var mode = b.getAttribute('data-mode');
      var already = !panel.hidden && panel.classList.contains('mode-' + mode);
      btns.forEach(function (x) { x.setAttribute('aria-expanded', 'false'); });
      panel.classList.remove('mode-artist', 'mode-style', 'mode-period', 'mode-museum');
      if (already) { panel.hidden = true; return; }
      panel.classList.add('mode-' + mode);
      panel.hidden = false;
      b.setAttribute('aria-expanded', 'true');
      panel.scrollLeft = 0;
      window.dispatchEvent(new Event('resize')); /* re-judge the arrows */
    });
  });
})();


/* 3 Sept (board item 43): on phones the artist, style and museum sets become
   pickers. The chip rows ran to 138 / 58 / 56 chips in one strip — the museum
   strip was 10,225 px wide, thirty screens of thumb-scrolling. The pickers are
   built from the chips themselves (one source of truth) in the sort control's
   phone look; the native select keeps the whole hit area. Period and subject
   stay chips; desktop is untouched (the section's CSS hides the pickers above
   700 px). */
(function () {
  'use strict';
  var panel = document.getElementById('facetPanel');
  var host = document.getElementById('facetSels');
  if (!panel || !host) return;
  var modes = { artist: 'fa', style: 'fs', museum: 'fm' };
  var labels = { artist: 'Artist', style: 'Style', museum: 'Museum' };
  Object.keys(modes).forEach(function (mode) {
    var chips = Array.prototype.slice.call(panel.querySelectorAll('a.chip.' + modes[mode]));
    if (!chips.length) return;
    var face = document.createElement('span');
    face.className = 'sortface facetsel';
    face.setAttribute('data-mode', mode);
    var sel = document.createElement('select');
    sel.className = 'sort';
    sel.setAttribute('aria-label', 'Browse by ' + mode);
    var first = document.createElement('option');
    first.value = '';
    first.textContent = labels[mode] + ' \u00b7 choose one';
    sel.appendChild(first);
    var current = '';
    chips.forEach(function (c) {
      var o = document.createElement('option');
      o.value = c.getAttribute('href');
      o.textContent = c.getAttribute('data-name') || c.textContent.trim();
      if (c.classList.contains('on')) { o.selected = true; current = o.textContent; }
      sel.appendChild(o);
    });
    var lab = document.createElement('span');
    lab.className = 'sortlabel';
    lab.setAttribute('aria-hidden', 'true');
    lab.textContent = current || first.textContent;
    sel.addEventListener('change', function () {
      if (sel.value) window.location.href = sel.value;
    });
    face.appendChild(sel);
    face.appendChild(lab);
    host.appendChild(face);
  });
  /* follow the panel: same mode, same open state */
  var sync = function () {
    var m = panel.className.match(/mode-[a-z]+/);
    host.className = 'facetsels' + (!panel.hidden && m ? ' ' + m[0] : '');
  };
  new MutationObserver(sync).observe(panel, { attributes: true, attributeFilter: ['class', 'hidden'] });
  sync();
})();


/* round sixteen-d: the nav underline completes its centre-out grow after a
   click — a bare :active retracted the moment the finger lifted and read as
   a broken flicker. The class persists until the navigation lands. */
(function () {
  document.querySelectorAll('.hdr nav a').forEach(function (a) {
    a.addEventListener('click', function () { a.classList.add('pressed'); });
  });
})();


/* KO_MOCKUPS — keep the three mockups in step with the chosen size + frame,
   and let any image open full-screen. The artwork stays the main image. */
(function () {
  var tag = document.getElementById('koMedia');
  var shots = document.querySelector('.shots');
  var M = [];
  if (tag) { try { M = JSON.parse(tag.textContent || '[]').filter(Boolean); } catch (e) {} }

  function sizeKey(t) { return (t || '').replace(/\s*×\s*/g, 'x').replace(/\s*cm\s*/g, '').trim(); }
  function frameKey(t) { t = (t || '').trim().toLowerCase(); return t === 'no frame' ? 'none' : t; }
  function sel(id) {
    var b = document.querySelector('#' + id + ' .on') || document.querySelector('#' + id + ' [aria-pressed="true"]');
    return b ? (b.getAttribute('data-val') || '') : '';
  }
  /* 15 Oct: each frame view's alt text says its frame and view, and follows the choice */
  function shotAlt(t, a) {
    var f = (/\|f=([^|]+)/.exec(a) || [])[1] || '', v = (/\|v=(\w+)/.exec(a) || [])[1] || 'front';
    var vv = v === 'angle' ? 'at an angle' : (v === 'corner' ? 'corner detail' : 'front');
    return t + ' \u2014 ' + (f === 'none' ? 'unframed' : f + ' frame') + ', ' + vv;
  }
  function paint() {
    if (!shots || !M.length) return;
    var key = 'ko|s=' + sizeKey(sel('pdpOpts')) + '|f=' + frameKey(sel('pdpFrames'));
    var order = ['front', 'angle', 'corner'];
    var want = order.map(function (v) {
      return M.filter(function (m) { return m.a === key + '|v=' + v; })[0];
    }).filter(Boolean);
    /* deploy 7 R, 28 Oct 2026: the room view, a fourth tile (.photo[data-koview=room]) whose media's alt is
       ko|room|s=<size>|f=<frame>|<caption>. On a size or frame click, if a room picture of the new size and frame
       exists, the tile's picture, alt and caption swap to it; if none, the tile stays as it is (its caption says its
       own size and frame, so nothing lies). Independent of the three views below, which keep their own rule; their
       loop never writes the room tile: it is excluded by data-koview, not by index, so a page with fewer than
       three views is safe too. The full-screen viewer lists the tile as it lists any .photo img, last.
       Deploy 7 R2: the tile is in the markup twice — the gallery's copy and, on phones, .room-phone under the buy
       block (one copy is hidden at any width) — so the swap writes every [data-koview=room] tile, not the first. */
    var rooms = document.querySelectorAll('[data-koview="room"]');
    if (rooms.length) {
      var rk = 'ko|room|' + key.slice(3) + '|';
      var rm = M.filter(function (m) { return (m.a || '').indexOf(rk) === 0; })[0];
      if (rm) {
        var cap = rm.a.slice(rm.a.lastIndexOf('|') + 1).replace(/^\s+|\s+$/g, '');
        rooms.forEach(function (room) {
          var rim = room.querySelector('img'), rcap = room.querySelector('.room-cap');
          if (rim) { rim.removeAttribute('srcset'); rim.src = rm.s; rim.alt = cap || shots.getAttribute('data-kotitle') || ''; }
          if (cap && !rcap) { rcap = document.createElement('p'); rcap.className = 'room-cap'; room.appendChild(rcap); }
          if (rcap) { if (cap) rcap.textContent = cap; else room.removeChild(rcap); }
        });
      }
    }
    if (!want.length) return;
    var photos = shots.querySelectorAll('.photo:not([data-koview="room"]) img');
    want.forEach(function (m, i) {
      if (photos[i]) {
        photos[i].removeAttribute('srcset'); photos[i].src = m.s;
        var ttl = shots.getAttribute('data-kotitle');
        if (ttl) photos[i].alt = shotAlt(ttl, m.a);
      }
    });
  }
  ['pdpOpts', 'pdpFrames'].forEach(function (id) {
    var host = document.getElementById(id);
    if (host) host.addEventListener('click', function () { setTimeout(paint, 30); });
  });
  paint();

  /* full-screen viewer */
  var box = document.createElement('div');
  box.className = 'kolb';
  box.innerHTML = '<button class="kolb-x" aria-label="Close">&#10005;</button>' +
                  '<img alt="">' +
                  '<div class="kolb-nav"><button data-d="-1">&#8249;</button><button data-d="1">&#8250;</button></div>';
  document.body.appendChild(box);
  var big = box.querySelector('img'), list = [], at = 0;

  function gather() {
    list = [];
    var main = document.querySelector('#pdpArt img');
    if (main) list.push(main.currentSrc || main.src);
    if (shots) shots.querySelectorAll('.photo img').forEach(function (im) { list.push(im.currentSrc || im.src); });
    return list;
  }
  function show(i) {
    gather();
    if (!list.length) return;
    at = (i + list.length) % list.length;
    big.src = list[at];
    /* next/prev call show() too — only lock on the way in, or the
       reference count climbs and hide() can never release it. */
    if (!box.classList.contains('on')) { box.classList.add('on'); koScrollLock(); }
  }
  function hide() { if (!box.classList.contains('on')) return; box.classList.remove('on'); koScrollUnlock(); }

  /* deploy 7 R2, 28 Oct 2026: on phones the room tile shows as a second copy under the buy block (.room-phone,
     outside .shots and not a .photo, so gather() never lists it and no picture is listed twice). A tap or Enter on
     that copy opens the viewer at the gallery's room tile — the one the list holds; hidden on phones, listed all
     the same, since the list is built from the markup, not from what is shown. */
  function roomAt() {
    var rt = shots && shots.querySelector('.photo[data-koview="room"]');
    return rt ? Array.prototype.slice.call(shots.querySelectorAll('.photo')).indexOf(rt) + 1 : 0;
  }
  document.addEventListener('click', function (e) {
    var art = e.target.closest && e.target.closest('#pdpArt .thumbbox');
    var ph = e.target.closest && e.target.closest('.shots .photo');
    var rp = e.target.closest && e.target.closest('.room-phone');
    if (art) { gather(); show(0); return; }
    if (rp) { var ri = roomAt(); if (ri) show(ri); return; }
    if (ph && shots) {
      var all = Array.prototype.slice.call(shots.querySelectorAll('.photo'));
      show(all.indexOf(ph) + 1);
    }
  });
  box.addEventListener('click', function (e) {
    var d = e.target.getAttribute && e.target.getAttribute('data-d');
    if (d) { show(at + parseInt(d, 10)); return; }
    if (e.target === big || e.target === box || e.target.className === 'kolb-x') hide();
  });
  document.addEventListener('keydown', function (e) {
    if (!box.classList.contains('on')) {
      /* 5 Sept: the zoom triggers are divs; open them from the keyboard too */
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var kArt = e.target.closest && e.target.closest('#pdpArt .thumbbox');
      var kPh = e.target.closest && e.target.closest('.shots .photo');
      var kRp = e.target.closest && e.target.closest('.room-phone');
      if (!kArt && !kPh && !kRp) return;
      e.preventDefault();
      if (kArt) { gather(); show(0); return; }
      if (kRp) { var kri = roomAt(); if (kri) show(kri); return; }
      if (shots) { var kAll = Array.prototype.slice.call(shots.querySelectorAll('.photo')); show(kAll.indexOf(kPh) + 1); }
      return;
    }
    if (e.key === 'Escape') hide();
    if (e.key === 'ArrowLeft') show(at - 1);
    if (e.key === 'ArrowRight') show(at + 1);
  });
})();

/* ============================================================
   Viewer zoom — the product is a museum scan; let people inspect it.
   Enhances the existing .kolb viewer: click zooms at the point,
   drag pans, arrows/Esc behave as before. Backdrop and \u00d7 close;
   the image itself no longer closes on click \u2014 it zooms.
   ============================================================ */
;(function () {
  var box = document.querySelector(".kolb");
  if (!box) return;
  var big = box.querySelector("img");
  if (!big) return;
  var s = 1, tx = 0, ty = 0, zoomed = false;
  function apply() { big.style.transform = zoomed ? ("translate(" + tx + "px," + ty + "px) scale(" + s + ")") : ""; }
  function reset() { zoomed = false; s = 1; tx = 0; ty = 0; box.classList.remove("kzed"); apply(); }
  big.style.transformOrigin = "0 0";
  /* hi-res swap: whenever the viewer shows the main artwork, upgrade it */
  big.addEventListener("load", function () {
    reset();
    var host = document.querySelector("#pdpArt .thumbbox[data-zoom-src]");
    var main = document.querySelector("#pdpArt .thumbbox img");
    if (host && main && big.src === (main.currentSrc || main.src)) {
      var hi = host.getAttribute("data-zoom-src");
      if (hi && big.src !== hi) big.src = hi;
    }
  });
  /* capture-phase click on the image: zoom instead of close */
  box.addEventListener("click", function (e) {
    if (e.target !== big) return;
    e.stopPropagation();
    if (moved) { moved = false; return; }
    if (zoomed) { reset(); return; }
    var r = big.getBoundingClientRect();
    var u = e.clientX - r.left, v = e.clientY - r.top;
    s = 2.5; zoomed = true;
    tx = u * (1 - s); ty = v * (1 - s);
    box.classList.add("kzed");
    apply();
  }, true);
  var moved = false;
  big.addEventListener("pointerdown", function (e) {
    if (!zoomed) return;
    e.preventDefault();
    var sx = e.clientX - tx, sy = e.clientY - ty, d0x = e.clientX, d0y = e.clientY;
    box.classList.add("kpan");
    function onMove(ev) {
      if (Math.abs(ev.clientX - d0x) + Math.abs(ev.clientY - d0y) > 4) moved = true;
      var ptx = tx, pty = ty;
      tx = ev.clientX - sx; ty = ev.clientY - sy; apply();
      var r = big.getBoundingClientRect();
      var vw = window.innerWidth, vh = window.innerHeight, m = 90;
      if (r.right < m || r.left > vw - m) { tx = ptx; }
      if (r.bottom < m || r.top > vh - m) { ty = pty; }
      apply();
    }
    function onUp() {
      box.classList.remove("kpan");
      window.removeEventListener("pointermove", onMove);
      window.removeEventListener("pointerup", onUp);
    }
    window.addEventListener("pointermove", onMove);
    window.addEventListener("pointerup", onUp);
  });
})();

/* Hangs well with — Shopify recommendations (purchases + similarity); the
   server-rendered tag-neighbour cards remain as instant fallback. */
;(function () {
  var rel = document.getElementById("related");
  if (!rel || !rel.getAttribute("data-rec")) return;
  var u = rel.getAttribute("data-rec") + "?section_id=related-products&product_id=" +
          rel.getAttribute("data-pid") + "&limit=4&intent=related";
  fetch(u).then(function (r) { return r.ok ? r.text() : ""; }).then(function (html) {
    if (!html) { if (window.KOsameSubject) window.KOsameSubject(); return; }
    var d = document.createElement("div"); d.innerHTML = html;
    var inner = d.querySelector("#related-rec");
    if (inner && inner.children.length > 0) { rel.innerHTML = inner.innerHTML; return; }
    if (window.KOsameSubject) window.KOsameSubject();
  }).catch(function () { if (window.KOsameSubject) window.KOsameSubject(); });
})();

/* deploy 2, 21 Oct 2026 (his pick 3A): when Shopify returns no recommendations, four prints of the same subject,
   read from the Archive filtered by the product's subject tag. The server-rendered cards stay if this fails.
   Called by the recommendations fetch above. */
window.KOsameSubject = function () {
  var rel = document.getElementById("related");
  var subj = rel && rel.getAttribute("data-subject");
  if (!subj) return;
  var here = location.pathname.replace(/\/$/, "");
  fetch("/collections/the-archive/subject-" + subj).then(function (r) { return r.ok ? r.text() : ""; })
    .then(function (html) {
      if (!html) return;
      var d = document.createElement("div"); d.innerHTML = html;
      var cards = Array.prototype.slice.call(d.querySelectorAll("a.acard")).filter(function (a) {
        var p = (a.getAttribute("href") || "").split("?")[0].replace(/\/$/, "");
        return p && here.slice(-p.length) !== p && p.slice(-here.length) !== here;
      }).slice(0, 4);
      if (cards.length === 4) rel.innerHTML = cards.map(function (a) { return a.outerHTML; }).join("");
    }).catch(function () {});
};

/* deploy 2, 21 Oct 2026 (his pick 2c): the paper line in the facts list opens The paper fold. */
document.addEventListener("click", function (e) {
  var b = e.target.closest && e.target.closest('[data-open-fold="paper"]');
  if (!b) return;
  var f = document.getElementById("foldPaper");
  if (!f) return;
  f.open = true;
  f.scrollIntoView({ behavior: "smooth", block: "start" });
});


/* ---------- 27 Aug: where you were -------------------------------------------
   Three parts of the site have to agree on what "where you were" means: the
   card you tap, the back link on the print, and the grid that has to rebuild
   itself to the same depth before it can scroll anywhere. So one place decides.

   It was landing people at the top because /collections/all and
   /collections/the-archive render the same 423 prints at two URLs, and the
   back link pointed at the first while the position had been saved against the
   second. The links now all point at the Archive, but a bookmark or a shared
   link can still arrive on the other one -- so both normalise to one key. It is
   the same listing; it is the same place in it. */
window.KOspot = (function () {
  var KEY = 'koArc';
  function norm(u) {
    u = (u || '').replace(/\/$/, '');
    if (u.indexOf('/collections/all') === 0) u = '/collections/the-archive' + u.slice(16);
    return u || '/';
  }
  function here() { return norm(location.pathname) + location.search; }
  function save(href, pages) {
    try {
      sessionStorage.setItem(KEY, JSON.stringify({
        u: here(), raw: location.pathname + location.search,
        h: href, y: window.scrollY || 0, p: pages || 1, t: Date.now()
      }));
    } catch (err) {}
  }
  function peek() {
    var s = null;
    try { s = JSON.parse(sessionStorage.getItem(KEY) || 'null'); } catch (err) {}
    if (!s || Date.now() - s.t > 1800000) return null;
    return s;
  }
  function read(consume) {
    var s = peek();
    if (!s || s.u !== here()) return null;
    if (consume) { try { sessionStorage.removeItem(KEY); } catch (err) {} }
    return s;
  }
  function target() { var s = peek(); return s ? (s.raw || s.u) : null; }
  /* deploy 7, 28 Oct 2026: the home page's first Noticed row is in the markup twice (a phone copy above the statement,
     the main grid's own; one copy is hidden at any width), so the first card by href can be the hidden one, and
     scrollIntoView on a hidden element does nothing. Prefer the match that has a box; fall back to the first. */
  function findCard(h) {
    if (!h) return null;
    var all = document.querySelectorAll('.acard[href="' + h + '"]'), i;
    for (i = 0; i < all.length; i++) if (all[i].getClientRects().length) return all[i];
    return all[0] || null;
  }
  /* Every card on the site, not only the ones in the archive grid. The homepage
     listing is the film's payoff and sits nearly seven screens down; losing your
     place there is worse than losing it in the archive, not better. Search,
     facets and "hangs well with" use the same card and get the same courtesy. */
  document.addEventListener('click', function (e) {
    var t = e.target;
    var a = t && t.closest ? t.closest('.acard') : null;
    if (!a || !a.getAttribute) return;
    save(a.getAttribute('href'), window.KOgridPages ? window.KOgridPages() : 1);
  }, true);
  /* --- the browser's own back button -----------------------------------------
     Most people never touch the link on the page; they swipe, or hit the arrow.
     Two cases. When the browser has the page in its back-forward cache it hands
     everything back itself -- grid, scroll, images -- and we must not interfere.
     When it does not (a phone under memory pressure, a long time away, iOS being
     iOS) the page reloads with 24 cards, and the browser then tries to restore a
     scroll offset it measured against a page eighteen thousand pixels longer.
     It clamps to the bottom of the short page and, because it restores after
     paint, it does it AFTER our own landing -- yanking you away from the print
     you were looking at. So when we hold a spot for this page, we take the job
     off the browser and give it back a few seconds later. */
  try {
    if ('scrollRestoration' in history && read(false)) {
      history.scrollRestoration = 'manual';
      setTimeout(function () { try { history.scrollRestoration = 'auto'; } catch (e) {} }, 6000);
    }
  } catch (err) {}

  /* And the safety net: if the cache did hand the page back but dropped us at
     the top anyway, put it right. Only when we are actually at the top -- a
     correct restore is left alone. */
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    var s = peek();
    if (!s || s.u !== here()) return;
    if ((window.scrollY || 0) > 200) return;
    var go = function () {
      var card = findCard(s.h);
      if (card) card.scrollIntoView({ block: 'center' });
      else if (s.y > 0) window.scrollTo(0, s.y);
    };
    go(); setTimeout(go, 250);
  });

  return { norm: norm, here: here, save: save, read: read, peek: peek, target: target, card: findCard, KEY: KEY };
})();

/* A page with no grid to rebuild only needs its scroll offset putting back. */
(function () {
  if (document.getElementById('agrid')) return;
  var s = window.KOspot.read(true);
  if (!s) return;
  function go() {
    var card = window.KOspot.card(s.h);
    if (card) card.scrollIntoView({ block: 'center' });
    else if (s.y > 0) window.scrollTo(0, s.y);
  }
  go();
  [200, 600, 1200, 2000].forEach(function (ms) { setTimeout(go, ms); });
})();

/* ---------- 27 Aug: the Archive is one continuous grid ----------
   It used to paginate: 24 prints, then a small chevron that navigated to
   page 2 and dropped you at the top of the page. Eighteen of those to see
   the catalogue, and on a phone the chevron sat at the far right of a row
   you had to reach the bottom of a long grid to find. Now the next page is
   fetched and appended in place, and the pager loads itself when it comes
   into view — five times, then it waits to be asked, so the footer stays
   reachable. Nothing jumps: new prints appear above the button, which does
   not move.

   The same block puts you back where you were. Leaving through a card saves
   the spot AND how many pages were open (sessionStorage, 30 minutes). The
   PDP back link prefers real history when the referrer is a collection, so
   the browser's bfcache restores everything for free; when it cannot, the
   grid re-appends to the same depth and scrolls the card you left from back
   into the middle of the screen. */
(function () {
  var KEY = 'koArc';
  var grid = document.getElementById('agrid');

  /* --- the PDP side: real history first, it is instant and exact --- */
  var back = document.querySelector('.wrap.pdp .back');
  if (back && !back.children.length) {
    /* Do not promise the archive when the spot we would return to is the
       film's own listing on the homepage. */
    var spot0 = window.KOspot && window.KOspot.peek();
    if (spot0 && spot0.u === '/') back.textContent = '\u2190 Back';
  }
  if (back) back.addEventListener('click', function (e) {
    /* bfcache hands back the grid, the scroll and the loaded images for free,
       so prefer it whenever the previous page was somewhere on this site that
       is not another print -- a collection, a facet, search, the homepage.
       Failing that, go to the exact URL the spot was saved against, which is
       what lets the restore below fire. The href is the last resort, and it
       now points at the Archive rather than /collections/all. */
    var ref = document.referrer || '';
    var same = ref.indexOf(location.origin) === 0;
    var fromPrint = ref.indexOf(location.origin + '/products/') === 0;
    if (history.length > 1 && same && !fromPrint) { e.preventDefault(); history.back(); return; }
    var to = window.KOspot && window.KOspot.target();
    if (to) { e.preventDefault(); location.href = to; }
  });

  if (!grid) return;

  var pagesOpen = 1;
  window.KOgridPages = function () { return pagesOpen; };
  var busy = false;
  var autoLeft = 5;

  function wrap() { return document.getElementById('loadWrap'); }
  function nextA() { return document.getElementById('loadMore'); }

  function shownRange() {
    var w = wrap(); if (!w) return null;
    var lab = w.querySelector('.mono'); if (!lab) return null;
    var m = lab.textContent.match(/(\d[\d,\.]*)\s*[\u2013-]\s*(\d[\d,\.]*)/);
    return m ? { el: lab, from: parseInt(m[1], 10) } : { el: lab, from: 1 };
  }

  function append(url) {
    if (busy || !url) return Promise.resolve(false);
    busy = true;
    var w = wrap();
    if (w) w.setAttribute('data-loading', '');
    return fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html) return false;
        var d = new DOMParser().parseFromString(html, 'text/html');
        var cards = d.querySelectorAll('#agrid .acard');
        if (!cards.length) return false;
        var frag = document.createDocumentFragment();
        for (var k = 0; k < cards.length; k++) frag.appendChild(document.importNode(cards[k], true));
        grid.appendChild(frag);
        pagesOpen++;

        var keep = shownRange();
        var nw = d.getElementById('loadWrap');
        var cur = wrap();
        if (cur) {
          if (nw) {
            cur.parentNode.replaceChild(nw, cur);
            var lab = nw.querySelector('.mono');
            var m = lab && lab.textContent.match(/[\u2013-]\s*(\d[\d,\.]*)([\s\S]*)$/);
            if (lab && m && keep) lab.textContent = keep.from + '\u2013' + m[1] + m[2];
            var prev = nw.querySelector('.pgb:not(#loadMore)');
            if (prev && prev.tagName === 'A') {
              var off = document.createElement('span');
              off.className = 'pgb off';
              off.textContent = prev.textContent;
              prev.parentNode.replaceChild(off, prev);
            }
          } else {
            cur.removeAttribute('data-loading');
          }
        }
        document.dispatchEvent(new CustomEvent('ko:cards-added'));
        return true;
      })
      .catch(function () { return false; })
      .then(function (ok) {
        busy = false;
        var w2 = wrap();
        if (w2) w2.removeAttribute('data-loading');
        watch();
        return ok;
      });
  }

  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('#loadMore') : null;
    if (!a || a.tagName !== 'A') return;
    e.preventDefault();
    autoLeft = 5;
    append(a.getAttribute('href'));
  });

  /* A scroll listener rather than an IntersectionObserver: the observer is
     the tidier tool but its callbacks could not be made to fire reliably
     under test here, and an unverifiable enhancement is worse than a plain
     one. rAF-throttled, passive, and it does nothing once the auto budget
     is spent. */
  var tick = null;
  function watch() {
    if (busy || autoLeft <= 0) return;
    var a = nextA();
    if (!a || a.tagName !== 'A') return;
    var r = a.getBoundingClientRect();
    if (r.top - window.innerHeight > 700) return;
    autoLeft--;
    append(a.getAttribute('href'));
  }
  function onScroll() {
    if (tick) return;
    tick = setTimeout(function () { tick = null; watch(); }, 120);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  onScroll();

  /* --- remembering the spot lives in KOspot, above --- */

  /* --- and give it back --- */
  var s = window.KOspot && window.KOspot.read(true);
  if (!s) return;

  var land = function () {
    var card = s.h && document.querySelector('#agrid .acard[href="' + s.h + '"]');
    if (card) card.scrollIntoView({ block: 'center' });
    else if (s.y > 0) window.scrollTo(0, s.y);
  };

  var want = (s.p || 1) - 1;
  (function step() {
    if (want <= 0) { land(); setTimeout(land, 400); return; }
    var a = nextA();
    if (!a || a.tagName !== 'A') { land(); setTimeout(land, 400); return; }
    want--;
    autoLeft = 5;
    append(a.getAttribute('href')).then(function (ok) {
      if (ok) step(); else { land(); setTimeout(land, 400); }
    });
  })();
})();

/* ---------- 21 Aug: PDP -> wall bridge ---------- */
/* Clicking "See it on your wall" saves the print you are looking at — with
   the size and frame currently selected — so the wall tool opens with just
   that print hung, not the opening trio. Read once by wall-tool.liquid. */
(function () {
  var wall = document.getElementById('pdpWall');
  if (!wall) return;
  wall.addEventListener('click', function () {
    try {
      var vars = [];
      var selv = document.getElementById('ko-variant-select');
      if (selv) Array.prototype.forEach.call(selv.options, function (o) {
        vars.push({
          id: +o.value,
          t: o.textContent.trim(),
          p: +((o.getAttribute('data-price') || '').replace(/[^0-9]/g, '')) || 0,
          pm: o.getAttribute('data-price') || ''
        });
      });
      var img = document.querySelector('#pdpArt img');
      var fr = document.querySelector('#pdpFrames .fsw.on span');
      var cur = selv && selv.selectedIndex >= 0 ? selv.options[selv.selectedIndex] : null;
      sessionStorage.setItem('ko:wallseed', JSON.stringify({
        h: (location.pathname.split('/products/')[1] || '').split('/')[0],
        t: ((document.getElementById('pdpTitle') || {}).textContent || '').trim(),
        img: img ? (img.currentSrc || img.src) : '',
        w: img && img.naturalWidth ? img.naturalWidth : 1000,
        hh: img && img.naturalHeight ? img.naturalHeight : 1400,
        size: cur ? (cur.getAttribute('data-size') || '') : '',
        frame: fr ? fr.textContent.trim() : '',
        v: vars
      }));
    } catch (e) {}
  });
})();


/* The phone buy bar was driven from here, 27 Aug to 31 Aug. Removed at Rareș's
   request along with its markup in sections/main-product.liquid and its styles
   in kommon-theme.css. It proxied #addBtn rather than duplicating the add-to-bag
   logic, so nothing else depended on it. Do not reinstate without asking him. */

/* ---------- Clarity client API — deploy 5, 28 October 2026 (his yes: tags, events, upgrade; never identify) ----------
   Microsoft Clarity's script, when the visitor has accepted analytics cookies, defines window.clarity. This block
   gives it three kinds of fact, so the Sunday read can filter sessions by where they came from and what was picked,
   instead of guessing from URLs: tags (set), events (event) and a request to keep the full recording of a session
   that added to the bag (upgrade). Every call is guarded — no Clarity, nothing runs — and nothing here names a
   person: no email, no name, no order number, and the identify API is never called. The source of the visit is read
   once, on the first page of the session, and kept for the visit in sessionStorage (ko:src) so a second page does
   not read "direct". Values: ad (a utm or click id from an ad), bio (the /ig and /fb links: utm_medium bio or page),
   social (Instagram or Facebook without a tag), search, direct. */
(function () {
  'use strict';
  function c() { if (typeof window.clarity === 'function') { try { window.clarity.apply(null, arguments); } catch (e) {} } }
  function source() {
    var s = '';
    try { s = sessionStorage.getItem('ko:src') || ''; } catch (e) {}
    if (s) return s;
    var q = location.search || '', ref = document.referrer || '';
    if (/[?&]utm_medium=(bio|page)(&|$)/.test(q)) s = 'bio';
    else if (/[?&](utm_[a-z]+|fbclid|igshid|gclid)=/.test(q)) s = 'ad';
    else if (/(^|\.)(instagram|facebook|l\.instagram)\.com/.test(ref)) s = 'social';
    else if (/(^|\.)(google|bing|duckduckgo|ecosia|yahoo)\./.test(ref)) s = 'search';
    else s = 'direct';
    try { sessionStorage.setItem('ko:src', s); } catch (e) {}
    return s;
  }
  c('set', 'source', source());
  var note = document.getElementById('pdpNote');
  var no = note ? (note.getAttribute('data-note-no') || '') : '';
  if (no) c('set', 'print', no);
  var form = document.getElementById('ko-product-form');
  if (form) {
    form.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('.fsw');
      if (!b || b.disabled) return;
      var val = (b.getAttribute('data-val') || b.textContent || '').trim();
      if (!val) return;
      var isFrame = !!b.closest('.fopts') || !!b.closest('#pdpFrames');
      c('set', isFrame ? 'frame' : 'size', val);
      c('event', isFrame ? 'frame_picked' : 'size_picked');
    });
    var sel = document.getElementById('ko-variant-select');
    if (sel) sel.addEventListener('change', function () {
      var o = sel.options[sel.selectedIndex];
      var val = o ? (o.getAttribute('data-size') || o.textContent || '').trim() : '';
      if (val) { c('set', 'size', val); c('event', 'size_picked'); }
    });
  }
  document.addEventListener('ko:cart-changed', function (e) {
    if (e && e.detail && e.detail.openBag) { c('event', 'add_to_bag'); c('upgrade', 'add_to_bag'); }
  });
  var drawer = document.getElementById('koDrawer');
  if (drawer && window.MutationObserver) {
    var wasOpen = drawer.classList.contains('open');
    new MutationObserver(function () {
      var open = drawer.classList.contains('open');
      if (open && !wasOpen) c('event', 'bag_opened');
      wasOpen = open;
    }).observe(drawer, { attributes: true, attributeFilter: ['class'] });
  }
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f && f.classList && f.classList.contains('bagmail-form')) c('event', 'bag_email_asked');
  }, true);
})();

/* ============================================================
   Compact pin -- deploy 7 P, 29 Oct 2026 (the assessment of 28 Oct, section 2 row 4; the mock of 28 Oct; variant A,
   22vh, applied by deploy7_patch.py --with-pin=A on his pick). On phones the artwork and its three views pin at the
   top of the screen as one block (21 Aug, rounds five and six) and the page reads in what is left under it. Once the
   visitor has scrolled past the buy block -- Add to bag has left the top of the screen by 24 px, and the sizes and
   frames above it with it -- this puts .pin-compact on the block; ko-pin-compact in kommon-theme.css caps the artwork
   at 22vh and fades the views. Scrolled back up until the button's top edge is on screen again, the class goes and
   the full block returns. The two lines are 24 px + the button's height apart: that gap is the hysteresis, so a
   visitor who stops near the line sees no flicker.
   The block keeps its full height while compact (min-height), so nothing under it moves and iOS, which has no scroll
   anchoring, does not lurch. Every measure is a rect, never scrollY, so the body lock of the bag, the menu and the
   full-screen viewer (koScrollLock) cannot flip the state. Phones only (700 px and under, the rule of the 38vh art).
   Passive listener, at most one check per frame. Not a buy bar: nothing in the compact block can be added to the bag.
   To go back: remove this block and ko-pin-compact in kommon-theme.css. ============================================================ */
(function KOPINCOMPACT() {
  'use strict';
  var art = document.getElementById('pdpArt');
  var btn = document.getElementById('addBtn');
  if (!art || !btn || !window.requestAnimationFrame || !window.matchMedia) return;
  var pin = art.parentNode;                          /* .pdp-grid > div:first-child, the sticky block */
  if (!pin || !pin.parentNode || !pin.parentNode.classList || !pin.parentNode.classList.contains('pdp-grid')) return;
  var mq = window.matchMedia('(max-width: 700px)');
  var PAST = 24;      /* px the button's bottom must be above the line before the block shrinks */
  var EDGE = true;    /* the line. true = the lower edge of the full block (the mock sheet of 28 Oct, its state (b)): the
                         block shrinks once Add to bag has gone 24 px under it, and the button, the frames and the facts
                         list come back into the larger pane under the small artwork; the views are hidden while the
                         frame buttons are on screen, one tap away on the artwork. false = the top edge of the screen:
                         the sizes, the frames and the button are all off screen when the views hide, so no choice is
                         made without its preview, and the shrink comes 462 px of scrolling later (390 x 844), after
                         the facts list has gone under the full block too. */
  var on = false, queued = false, w0 = window.innerWidth;
  var top0 = parseFloat(window.getComputedStyle(pin).top) || 0;   /* where the block sticks (0 on phones) */

  function line() { return EDGE ? top0 + pin.getBoundingClientRect().height : 0; }
  function set(v) {
    if (v === on) return;
    on = v;
    if (v) {
      if (!pin.style.minHeight) pin.style.minHeight = pin.getBoundingClientRect().height + 'px';
      pin.classList.add('pin-compact');
    } else {
      pin.classList.remove('pin-compact');
      pin.style.minHeight = '';                       /* the height is back in the same step (no height transition) */
    }
  }
  function check() {
    queued = false;
    if (!mq.matches) { set(false); return; }
    var r = btn.getBoundingClientRect();
    if (!r.height) { set(false); return; }                                  /* no button on screen: nothing to pass */
    var l = line();
    if (on ? r.top > l : r.bottom < l - PAST) set(!on);
  }
  function queue() { if (!queued) { queued = true; window.requestAnimationFrame(check); } }

  window.addEventListener('scroll', queue, { passive: true });
  window.addEventListener('load', queue);
  window.addEventListener('resize', function () {
    if (window.innerWidth === w0) return;            /* iOS fires resize as its toolbars move; only a width change counts */
    w0 = window.innerWidth;
    on = false; pin.classList.remove('pin-compact'); pin.style.minHeight = '';
    top0 = parseFloat(window.getComputedStyle(pin).top) || 0;
    queue();
  });
  queue();
})();
